import determineFieldType from '../common/determineFieldType';
import { requestGet as wsRequestGet, requestPost as wsRequestPost, requestDelete as wsRequestDelete } from './_wsApiFetchData';

export async function getPriceRules(productId, language, timeZone, cancelToken) {
  let wsApiResult = await wsRequestGet(`/admin/Product/price-rules`, language, timeZone, {
    ProductId: productId
  }, cancelToken);

  return wsApiResult;
}

export async function deleteRule(ruleId, language, timeZone, cancelToken) {
  let wsApiResult = await wsRequestGet(`/admin/Product/delete-rule`, language, timeZone, {
    ruleId: ruleId
  }, cancelToken);

  return wsApiResult;
}

export async function addRule(rule, language, timeZone, cancelToken) {
  let wsApiResult = await wsRequestPost(`/admin/Product/add-rule`, language, timeZone, rule, null, cancelToken);

  return wsApiResult;
}

export async function editRule(rule, language, timeZone, cancelToken) {
  rule.from = rule.from || undefined;
  rule.to = rule.to || undefined;
  let wsApiResult = await wsRequestPost(`/admin/Product/edit-rule`, language, timeZone, rule, null, cancelToken);

  return wsApiResult;
}


export async function searchProduct(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const {
    providerName,
    facilityName,
    providerId,
    facilityId,
    groupId,
    groupName,
    groupHeader,
    name,
    category,
    type,
    isVisible,
    isExclusive,
    productId
  } = filters;

  const params = {
    ProviderName: providerName || undefined,
    FacilityName: facilityName || undefined,
    ProviderId: providerId || undefined,
    FacilityId: facilityId || undefined,
    GroupId: groupId || undefined,
    GroupName: groupName || undefined,
    // Optional; absent the endpoint filters on nothing, so the old admin's
    // request is unchanged.
    GroupHeader: groupHeader || undefined,
    Name: name || undefined,
    Category: category || undefined,
    Type: type || undefined,
    IsVisible: isVisible === 'true' || undefined,
    IsExclusive: isExclusive === 'true' || undefined,
    Id: productId || undefined,
    page: skipPages || 1,
    count: resultsCount || 15
  };

  return toPascal(await wsRequestGet('/admin/product/search', language, timeZone, params, cancelToken));
}

export async function getBookableProductsOfFacility(facilityId, language, timeZone, cancelToken) {
  return await wsRequestGet('/admin/product/bookable-of-facility', language, timeZone, { facilityId }, cancelToken);
}

export async function searchMembershipProducts(options, language, timeZone, cancelToken) {
  const { filters } = options;
  const { MembershipId } = filters;
  const params = {
    MembershipId
  };

  return toPascal(await wsRequestGet('/admin/product/memberships/products/search', language, timeZone, params, cancelToken));
}

export async function searchProductFields(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const { ProductId } = filters;
  const params = {
    Page: skipPages || 1,
    Count: resultsCount,
    ProductId
  };

  return toPascal(await wsRequestGet('/admin/product/fields/search', language, timeZone, params, cancelToken));
}

export async function getProduct(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/product/${id}`, language, timeZone, null, cancelToken));
}

export async function getBooking(id, language, timeZone, cancelToken) {
  var booking = await wsRequestGet(`/admin/product/booking/${id}`, language, timeZone, null, cancelToken);
  booking.maxSignUpInAdvanceInDays = booking.maxSignUpInAdvanceInDays || '';
  booking.slug = booking.slug || '';
  if (!booking.subType)
  {
    delete booking.subType;
  }

  var pascal = toPascal(booking);
  return pascal;
}

export async function getMembershipProduct(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/product/memberships/products/${id}`, language, timeZone, null, cancelToken));
}

export async function getProductField(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/product/fields/${id}`, language, timeZone, null, cancelToken));
}

export async function deleteMembershipProduct(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestDelete(`/admin/product/memberships/products/${id}/delete`, language, timeZone, null, null, cancelToken));
}

function getCategory(category) {
  return Array.isArray(category) ? category.join(',') : category;
}

function readCategories(categoriesIncluded) {
  if (!categoriesIncluded) {
    return '';
  }

  return Array.isArray(categoriesIncluded)
    ? categoriesIncluded.join(',') : categoriesIncluded;
}

function clean(stringValue) {
  return stringValue ? stringValue.trim() : null;
}

export async function generatePreview(picture, language, timeZone, cancelToken) {
  let wsApiResult = await wsRequestGet(`/admin/Product/generate-picture-preview`, language, timeZone, {url: picture}
  , cancelToken);

  return wsApiResult;
}
export async function editBookingData( editedData, asNew, language, timeZone, cancelToken) {
  const dataToSend = Object.assign({
    Id: editedData.Id,
    Name: clean(editedData.Name),
    Category: editedData.Category.trim() == '' ?  'None' : getCategory(editedData.Category),
    SubTypeId: editedData.SubType ? editedData.SubType.Id : undefined,
    Description: clean(editedData.Description),
    PurchaseText: clean(editedData.PurchaseText),
    ExternalLink: clean(editedData.ExternalLink),
    FacilityId: editedData.Facility.value,
    IsVisible: editedData.IsVisible,
    IsExclusive: editedData.IsExclusive,
    IsClassActivity: editedData.IsClassActivity,
    IsBundleEnabled: editedData.IsBundleEnabled,
    GroupId: editedData.Group && editedData.Group.value ? editedData.Group.value : undefined,
    GroupHeader: editedData.GroupHeader,
    Photos: {
      SquareUrl: clean(editedData.Photos.SquareUrl),
      BannerUrl: clean(editedData.Photos.BannerUrl) || '1ee9d569-4a6d-4e2e-b325-300b946f9923-list',
      HugeUrl: clean(editedData.Photos.HugeUrl),
      ListUrl: clean(editedData.Photos.ListUrl),
      ListPreviewUrl: clean(editedData.Photos.ListPreviewUrl),
      SquarePreviewUrl: clean(editedData.Photos.SquarePreviewUrl),
      HugePreviewUrl: clean(editedData.Photos.HugePreviewUrl),
    },
    ProviderId: editedData.Provider.value,
    SchemeName: editedData.Category.trim() == 'None' || editedData.Category.trim() == '' ? "Undefined" : editedData.SchemeName,
    Summary: clean(editedData.Summary),
    TermsOfServiceLink: clean(editedData.TermsOfServiceLink),
    PriceAmount: editedData.Price.Amount,
    TaxIndex: {
      // The form holds a percentage (25 = 25%); the API stores a fraction (0.25).
      AsDecimal: taxPercentageToFraction(editedData.Price.TaxIndex.AsDecimal)
    },
    CurrencyIsoCode: editedData.Price.CurrencyIsoCode || 'DKK',
    SignUpDeadLine: editedData.SignUpDeadLine,
    SignUpCancellationDeadline: editedData.SignUpCancellationDeadline,
    BundleDeadline: clean(editedData.BundleDeadline),
    MaxSignUpInAdvanceInDays:
    editedData.MaxSignUpInAdvanceInDays === undefined || 
    editedData.MaxSignUpInAdvanceInDays === null ||
    editedData.MaxSignUpInAdvanceInDays === ''
    ? undefined : editedData.MaxSignUpInAdvanceInDays,
    PriceLevel: editedData.Price.Level,
    ServiceFeeAmount: editedData.Price.ServiceFeeAmount || 0,
    Slug: editedData.Slug,
    ConditionText: editedData.ConditionText,
    PicturePreview: editedData.PicturePreview,
    ProductFeature: editedData.ProductFeature,
    SortingPreference: editedData.SortingPreference,
    SaveAsNew: !!asNew,

    //membership fields
    DefaultPriceCoverage: parseInt(editedData.DefaultPriceCoverage) || null ,
    MaxDiscountedAmount: parseInt(editedData.MaxDiscountedAmount) || null,
    CategoriesIncluded: 
    editedData.CategoriesIncluded !== null && 
    editedData.CategoriesIncluded !== undefined &&
    typeof(editedData.CategoriesIncluded) == 'string' ?
      editedData.CategoriesIncluded : null,
    MaxPurchasesIncluded: parseInt(editedData.MaxPurchasesIncluded) || null,
    IsAllProductsIncluded: sendBoolean(editedData.IsAllProductsIncluded),
    BillingLength: parseInt(editedData.BillingLenght) || null,   //typo here
    BillingStartType: editedData.BillingStartType != null && editedData.BillingStartType != undefined ? 
      editedData.BillingStartType.toString() : null,
    BillingType: editedData.BillingType != null && editedData.BillingType != undefined ?
      editedData.BillingType.toString() : null,
    DefaultPriceLevelCoverage: parseInt(editedData.DefaultPriceLevelCoverage) || null,
    DeferredStart: editedData.DeferredStart != null && editedData.DeferredStart != undefined ?
        editedData.DeferredStart.toString() : null,
    LogicType: editedData.LogicType != null && editedData.LogicType != undefined ?
      editedData.LogicType.toString() : null,
    CoveredFacilityId: editedData.CoveredFacilityId != null && editedData.CoveredFacilityId != undefined ?
      editedData.CoveredFacilityId : null,
    TrackDiscountedAmount: sendBoolean(editedData.TrackDiscountedAmount),
    FixedDiscount:  parseFloat(editedData.FixedDiscount) || null,
    OneTimeSubscription: sendBoolean(editedData.OneTimeSubscription), 
    // 0 is a real termination length and is sent as 0; only an empty field is null
    // (the backend keeps the stored value then). `|| null` turned 0 into null.
    TerminationLength: toIntOrNull(editedData.TerminationLenght), //typo here
    TerminationStartType: editedData.TerminationStartType != null && editedData.TerminationStartType != undefined ?
      editedData.TerminationStartType.toString() : null,
    TerminationType: editedData.TerminationType != null && editedData.TerminationType != undefined ?
      editedData.TerminationType.toString() : null,
    BucketLength: parseInt(editedData.BucketLenght) || null, //typo here
    BucketStartType: editedData.BucketStartType != null && editedData.BucketStartType != undefined ?
        editedData.BucketStartType.toString() : null,
    BucketType: editedData.BucketType != null && editedData.BucketType != undefined ?
        editedData.BucketType.toString() : null,
    RequiredDomain: editedData.RequiredDomain,
  });

  const result = toPascal(await wsRequestPost('/admin/product/edit-booking', language, timeZone, dataToSend, null, cancelToken));

  return asNew ? result.Id : editedData.Id;
}

function toIntOrNull(value) {
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
}

// parseFloat, not parseInt, so 12.5% stays 12.5%; a comma decimal is accepted too.
function taxPercentageToFraction(percentage) {
  return (parseFloat(String(percentage ?? '').replace(',', '.')) || 0) / 100;
}

function sendBoolean(value) {
  return value === null ? null :
  value === undefined ? undefined :
  value === true ? true :
  value === false ? false :
     typeof(value) == 'string' ? 
     value.toLowerCase() == "true" ? true : 
     value.toLowerCase() == "false" ? false 
      : null 
      : null;
}

export async function createBooking(data, language, timeZone, cancelToken) {

  const dataToSend = Object.assign({
    Type: clean(data.Type),
    Name: clean(data.Name),
    Category: data.Category.trim() == '' ? 'None' : getCategory(data.Category),
    Description: clean(data.Description),
    PurchaseText: clean(data.PurchaseText),
    ExternalLink: clean(data.ExternalLink),
    FacilityId: data.Facility ? data.Facility.value : undefined,
    IsVisible: data.IsVisible,
    IsExclusive: data.IsExclusive,
    IsClassActivity: data.IsClassActivity,
    IsBundleEnabled: data.IsBundleEnabled,
    GroupId: data.Group && data.Group.value ? data.Group.value : undefined,
    GroupHeader: data.GroupHeader,
    Photos: {
      SquareUrl: clean(data.Photos.SquareUrl),
      BannerUrl: clean(data.Photos.BannerUrl) || '1ee9d569-4a6d-4e2e-b325-300b946f9923-list',
      HugeUrl: clean(data.Photos.HugeUrl),
      ListUrl: clean(data.Photos.ListUrl),
      ListPreviewUrl: clean(data.Photos.ListPreviewUrl),
      SquarePreviewUrl: clean(data.Photos.SquarePreviewUrl),
      HugePreviewUrl: clean(data.Photos.HugePreviewUrl),
    },
    ProviderId: data.Provider.value,
    SchemeName: data.SchemeName || 'Undefined',
    Summary: clean(data.Summary),
    TermsOfServiceLink: clean(data.TermsOfServiceLink),
    ConditionText: clean(data.ConditionText),
    PriceAmount: data.Price.Amount,
    TaxIndex: {
      AsDecimal: taxPercentageToFraction(data.Price.TaxIndex.AsDecimal)
    },
    CurrencyIsoCode: data.Price.CurrencyIsoCode,
    SignUpDeadLine: data.SignUpDeadLine,
    SignUpCancellationDeadline: data.SignUpCancellationDeadline,
    BundleDeadline: clean(data.BundleDeadline),
    MaxSignUpInAdvanceInDays: data.MaxSignUpInAdvanceInDays || 0,
    PriceLevel: data.Price.Level,
    ServiceFeeAmount: data.Price.ServiceFeeAmount || 0,
    Slug: data.Slug,
    PicturePreview: data.PicturePreview,
    ProductFeature: data.ProductFeature,
    SortingPreference: data.SortingPreference,
    SubTypeId: data.SubType ? data.SubType.Id : undefined
  });

  const response = toPascal(await wsRequestPost('/admin/product/create-booking', language, timeZone, dataToSend, null, cancelToken));

  return response;
}

export async function saveMembershipProduct(loadedData, formData, language, timeZone, cancelToken) {
  const {
    Id,
    MembershipId
  } = loadedData;

  const {
    ExtraPrice,
    ProductId
  } = formData;

  const dataToSend = Object.assign({
    Id,
    ExtraPrice,
    MembershipId,
    ProductId
  });

  toPascal(await wsRequestPost('/admin/product/memberships/products/edit', language, timeZone, dataToSend, null, cancelToken));

  return getMembershipProduct(Id, language, timeZone, cancelToken);
}

export async function createMembershipProduct(data, membershipId, language, timeZone, cancelToken) {
  const {
    ExtraPrice,
    ProductId
  } = data;

  const dataToSend = Object.assign({
    ExtraPrice,
    MembershipId: membershipId,
    ProductId
  });

  const {
    Id
  } = toPascal(await wsRequestPost('/admin/product/memberships/products/create', language, timeZone, dataToSend, null, cancelToken));

  return getMembershipProduct(Id, language, timeZone, cancelToken);
}

export async function createProductField(data, productId, language, timeZone, cancelToken) {
  const {
    Name,
    Type,
    IsRequired
  } = data;

  const dataToSend = Object.assign({
    Name,
    Type,
    IsRequired,
    ProductId: productId
  });

  const {
    Id
  } = toPascal(await wsRequestPost('/admin/product/fields/create', language, timeZone, dataToSend, null, cancelToken));

  return getProductField(Id, language, timeZone, cancelToken);
}

export async function deleteProductField(id, language, timeZone, cancelToken) {
  return await wsRequestDelete(`/admin/product/fields/delete/${id}`, language, timeZone, null, null, cancelToken);
} 

export async function saveProductField(loadedData, formData, language, timeZone, cancelToken) {
  const {
    Id
  } = loadedData;

  const {
    Name,
    Type,
    IsRequired,
    ProductId
  } = formData;

  const dataToSend = Object.assign({
    Id,
    Name,
    Type,
    IsRequired,
    ProductId
  });

  toPascal(await wsRequestPost('/admin/product/fields/edit', language, timeZone, dataToSend, null, cancelToken));

  return getProductField(Id, language, timeZone, cancelToken);
}

export async function lookupByNameOrId(key, type, language, timeZone, cancelToken) {
  if (!key) {
    return [];
  }

  const fieldName = await determineFieldType(key);
  const supportedFields = ['Id', 'Name'];

  if (supportedFields.indexOf(fieldName) < 0) {
    return [];
  }

  if (fieldName === 'Id') {
    const { Id, Name } = await getMembership(key, language, timeZone, cancelToken);

    return [{
      label: `${Name}`,
      value: Id
    }];
  } if (fieldName === 'Name') {
    try {
      const options = {
        filters: {
          resultsCount: 5,
          name: key,
          type
        }
      };
      const results = await searchProduct(options, language, timeZone, cancelToken);

      return results.map(({ Id, Name }) => ({
        label: `${Name}`,
        value: Id
      }));
    }
    catch (e) {
      console.error(JSON.stringify(e));
    }
  }
}

export async function saveImage(picture, url, mimeType, language, timeZone) {
  const request = {
    picture,
    url,
    mimeType
  };

  try {
    const response = await wsRequestPost('/admin/product/upload-picture', language, timeZone, request, null);
    
    return {
      success: true,
      data: response
    }
  } catch (error) {
    return {
      success: false,
      message: `Error: ${error}`
    }
  }
}

export async function generateSalesReportNew(options, language, timeZone, cancelToken) {

  const { from, to, facility, byActivityDate, includeCancellations, fromReportTable, cancellationsAsOwnRows } = options;
  const facilityId = facility ? facility.value : undefined;

  const params = {
    From: from || undefined,
    To: to || undefined,
    FacilityId: facilityId,
    byActivityDate: byActivityDate,
    IncludeCancellations: includeCancellations,
    FromReportTable: fromReportTable || false,
    cancellationsAsOwnRows: cancellationsAsOwnRows || false
  };
  console.log(JSON.stringify(params));
  const data = await wsRequestGet(
    "/admin/Product/generate-sales-report",
    language,
    timeZone,
    params,
    cancelToken
  );
  return data;
}

export async function generateSalesReportOld(options, language, timeZone, cancelToken) {

  const { from, to, facility, byActivityDate, includeCancellations } = options;
  const facilityId = facility ? facility.value : undefined;

  const params = {
    From: from || undefined,
    To: to || undefined,
    FacilityName: facilityId,
    byActivityDate: byActivityDate,
    IncludeCancellations: includeCancellations,
    FromReportTable: true
  };
  console.log(JSON.stringify(params));
  const data = await wsRequestGet(
    "/admin/Product/generate-sales-report",
    language,
    timeZone,
    params,
    cancelToken
  );
  return data;
}

export async function getSubTypes(language, timeZone, cancelToken) {
  try {
    const data = await wsRequestGet(
      "/admin/Product/subtypes",
      language,
      timeZone,
      null,
      cancelToken
    );

    return data;
    
  } catch (e) {
    console.error(`unable to delete rule ${ruleId}: ${e}`);
    return {
      success: false,
    };
  }
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}
